export default "__VITE_ASSET__c4e6LZHC__"